// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import InfoIcon from '@mui/icons-material/Info'
import { Box, Stack } from '@mui/material'
import { FormProvider } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { displaySnackbar } from '../../../actions/main'
import { emailExists, inviteRequiredExpert } from '../../../api/healthCareService'
import { useCreateUserMutation } from '../../../api/mutations/__generated__/createUser.gql'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import { RouterRouteId } from '../../../routers/_props'
import { useAppDispatch } from '../../../store'
import { parsePhoneNumber } from '../../../utils/formUtils'
import CommonLoaderBackdrop from '../../Common/CommonLoaderBackdrop'
import DeletionBanner from '../../Common/DeletionBanner/DeletionBanner'
import FormContainer from '../../Common/form/formContainer/FormContainer'
import FormSection from '../../Common/form/formSection/FormSection'
import SaveComponent from '../../Common/SaveComponent/SaveComponent'
import SearchRpps from '../../Common/searchRpps/SearchRpps'
import ActionDialog from '../../feature/actionDialog/ActionDialog'
import NetworkCallout from '../../feature/networkCallout/NetworkCallout'
import { UserData } from '../_props'
import sxs from '../_sxs'
import { ContactPhone } from '../fields/ContactPhone'
import { Email } from '../fields/Email'
import SecuredEmail from '../fields/SecuredEmail'
import IdentitySection from '../sections/IdentitySection'
import ProfessionalSection from '../sections/ProfessionalSection'
import useGetSavableUserFormData from '../utils/useGetSavableUserFormData'
import useUserFormBase from '../utils/useUserFormBase'
import {
    getGetIdsHealthcareservicesHcsIdRequiredExpertsIdQueryKey,
    getGetIdsHealthcareservicesHcsIdRequiredExpertsQueryKey,
    useDeleteIdsHealthcareservicesHcsIdRequiredExpertsRequiredExpertId,
} from '@toktokdoctech/tokapi-client'
import { useQueryClient } from '@tanstack/react-query'
import useUserPermissions from '../../../hooks/useUserPermissions'

type RequiredExpertFormProps = {
    mode: 'CREATION' | 'EDITION'
    data: UserData
}

const RequiredExpertForm = ({ mode, data }: RequiredExpertFormProps) => {
    const dispatch = useAppDispatch()
    const currentHcs = useCurrentHcs()
    const { hasUserPermission } = useUserPermissions()
    const params = useParams<RouterRouteId>()
    const userId = params.id ?? ''
    const hcsId = currentHcs.id

    const [createUserMutation] = useCreateUserMutation()
    const { getSavableUserFormData } = useGetSavableUserFormData()
    const queryClient = useQueryClient()

    const {
        form,
        state,
        update,
        editMode,
        certifiedAccessMode,
        isLoading,
        hasFormError,
        globalErrorMessage,
        setGlobaleErrorMessage,
        clearGlobaleErrorMessage,
        userRpps,
        searchRppsHasError,
        handleRppsChange,
        cancelButton,
        redirectButton,
        buildHandleSaveTrigger,
        buildHandleSave,
        buildHandleCancel,
        buildSaveButtonAction,
        setShouldRedirect,
    } = useUserFormBase({ mode, data, existingUserLabel: 'Le téléconsultant', returnLocation: '/network' })

    const { mutate: deleteRequiredExpert, isPending: isDeletingRequiredExpert } =
        useDeleteIdsHealthcareservicesHcsIdRequiredExpertsRequiredExpertId({
            mutation: {
                onSuccess: () => {
                    const requiredExpertsListQueryKey = getGetIdsHealthcareservicesHcsIdRequiredExpertsQueryKey(hcsId)
                    const requiredExpertByIdQueryKey = getGetIdsHealthcareservicesHcsIdRequiredExpertsIdQueryKey(
                        hcsId,
                        userId,
                    )
                    queryClient.invalidateQueries({ queryKey: requiredExpertsListQueryKey })
                    queryClient.removeQueries({ queryKey: requiredExpertByIdQueryKey })
                    dispatch(displaySnackbar('success', 'Le téléconsultant supprimé avec succès'))
                    update({ shouldBlockNavigation: false })
                    setShouldRedirect(true)
                },
                onError: (err: unknown) => {
                    console.error({ err })
                    dispatch(displaySnackbar('error', 'Suppression du téléconsultant impossible'))
                },
            },
        })

    const save = async (userData: UserData) => {
        update({
            isLoading: true,
            loaderMessage: editMode ? 'Enregistrement des modifications' : 'Création du téléconsultant',
        })
        try {
            const formData = await getSavableUserFormData(userData, editMode)
            const { objectId: savableUserId, email, initialEmail, rpps } = userData
            const {
                healthActivityInfo: { qualification, profession, speciality, securedEmail },
            } = formData
            const { firstName, lastName, title, civility, contactPhone, privatePhone } = formData

            const checkExistingEmail = initialEmail !== email
            if (checkExistingEmail) {
                const existing = await emailExists(email, hcsId)
                if (Boolean(existing) && existing.objectId !== userData.objectId) {
                    throw new Error('Cette adresse de courriel est déjà associée à un compte.')
                }
            }

            if (editMode) {
                if (!savableUserId) throw new Error('Erreur: utilisateur inconnu')
            } else {
                let invitationTargetId = userData.objectId

                if (!savableUserId && email) {
                    const res = await createUserMutation({
                        variables: {
                            input: {
                                fields: {
                                    ACL: {
                                        roles: [
                                            { roleName: hcsId, read: true, write: false },
                                            { roleName: `${hcsId}_WriteOnly`, read: false, write: true },
                                            { roleName: 'AdminLvlOne', read: true, write: true },
                                        ],
                                    },
                                    email,
                                    firstName,
                                    prefix: title,
                                    civility,
                                    username: email,
                                    password: ToktokdocLib.Utils.generateRandomPassword(8),
                                    twoFactorSecret: ToktokdocLib.Utils.generateRandomString(16),
                                    twoFactorIsEnabled: true,
                                    creationSource: 'Direct TokTokDoc',
                                    lastName: lastName.toUpperCase().trim(),
                                    sex: civility === 'MME' ? 'F' : 'M',
                                    contactPhone: parsePhoneNumber(contactPhone),
                                    privatePhone: parsePhoneNumber(privatePhone),
                                    isReal: true,
                                    isEnabled: true,
                                    address: { createAndLink: {} },
                                    bankInfo: { createAndLink: {} },
                                    extraHealthSystemInfo: {
                                        createAndLink: {
                                            rppsNum: rpps?.length === 11 ? Number(rpps) : undefined,
                                            adeliNum: rpps?.length === 9 ? rpps : undefined,
                                        },
                                    },
                                    extraHealthActivityInfo: {
                                        createAndLink: {
                                            qualification: { link: qualification?.objectId ?? null },
                                            profession,
                                            speciality: { link: speciality?.objectId ?? null },
                                            securedEmail,
                                        },
                                    },
                                    extraUsageInfo: {
                                        createAndLink: {
                                            technicalConfig: { createAndLink: { isTransEnabled: true } },
                                        },
                                    },
                                },
                            },
                        },
                    })

                    const createdUser = res.data?.createUser?.user
                    if (!createdUser) throw new Error('Utilisateur non créé')

                    invitationTargetId = createdUser.objectId
                }

                if (invitationTargetId) {
                    await inviteRequiredExpert(invitationTargetId, hcsId)
                }
            }

            update({ isLoading: false, loaderMessage: undefined })
            dispatch(
                displaySnackbar(
                    'success',
                    editMode
                        ? 'Les modifications ont bien été enregistrées !'
                        : 'Le téléconsultant a bien été ajouté !',
                ),
            )
            return true
        } catch (err) {
            console.error({ err })

            if (err instanceof Error) {
                clearGlobaleErrorMessage()
                dispatch(displaySnackbar('error', err.message))
            }

            if (typeof err === 'string') {
                setGlobaleErrorMessage(err)
                dispatch(displaySnackbar('error', err))
            }

            const errAny = err as any
            if (errAny.code && [202, 203].includes(errAny.code)) {
                setGlobaleErrorMessage(
                    `Ce courriel est déjà associé à un compte existant. Vous pouvez saisir un autre courriel, ou annuler l'ajout de l'utilisateur en cours.`,
                )
            }

            update({ isLoading: false, loaderMessage: undefined })
            return undefined
        }
    }

    const handleSave = buildHandleSave(save)
    const handleSaveTrigger = buildHandleSaveTrigger(handleSave)
    const handleCancel = buildHandleCancel()

    return (
        <>
            <FormProvider {...form}>
                {!data.rpps && (
                    <FormContainer sx={{ ...sxs.UserForm, marginY: '2.125rem' }}>
                        <SearchRpps
                            displayTitle
                            onRppsUserChange={handleRppsChange}
                            selectedValue={undefined}
                            codeprofession={undefined}
                            required={certifiedAccessMode}
                            error={searchRppsHasError && !userRpps}
                            errorMessage="Cette information est obligatoire et n'a pas été renseignée"
                        />
                    </FormContainer>
                )}
                <Box sx={sxs.UserFormContainer}>
                    <FormContainer sx={sxs.UserForm}>
                        <IdentitySection />
                        <ProfessionalSection />
                        <FormSection label="Coordonnées de contact">
                            <Email isDisabled />
                            <SecuredEmail readonly />
                            {editMode && <ContactPhone isDisabled />}
                        </FormSection>

                        <Stack alignItems="center" gap="1.5rem" sx={{ width: '100%' }}>
                            {!editMode && (
                                <Box sx={{ minWidth: '34rem', width: '75%', marginTop: '3.5rem' }}>
                                    <NetworkCallout text="Après enregistrement, vous pourrez inviter le requis à rejoindre votre établissement. L'identifiant de connexion et le mot de passe provisoire seront ensuite envoyés à l'utilisateur sur son courriel de contact" />
                                </Box>
                            )}
                            {mode === 'CREATION' && (
                                <SaveComponent
                                    withMargin={false}
                                    saveButton={{ action: buildSaveButtonAction(handleSaveTrigger), isLoading }}
                                    cancelButton={{
                                        action: handleCancel,
                                        displayed: currentHcs.isCurrentUserCertified,
                                    }}
                                    disableAll={isLoading}
                                    shouldBlockNavigation={state.shouldBlockNavigation}
                                    errorMessage={
                                        hasFormError || Boolean(globalErrorMessage) ? globalErrorMessage : undefined
                                    }
                                />
                            )}
                        </Stack>
                    </FormContainer>
                    {mode === 'EDITION' && hasUserPermission('ADMIN') && (
                        <DeletionBanner
                            bannerTitle="Êtes-vous sûr de vouloir supprimer le téléconsultant ?"
                            bannerLabel="Supprimer le téléconsultant"
                            bannerSubLabel="Après confirmation, la suppression sera définitive"
                            onConfirm={() => deleteRequiredExpert({ hcsId, requiredExpertId: userId })}
                            isPending={isDeletingRequiredExpert}
                        />
                    )}
                </Box>
            </FormProvider>
            {isLoading && <CommonLoaderBackdrop open label={state.loaderMessage} />}
            <ActionDialog
                open={Boolean(state.redirectKey)}
                onClose={() => update({ redirectKey: undefined })}
                title={`Vous allez être redirigé vers l'interface de changement de ${
                    state?.redirectKey === 'email' ? 'courriel de contact' : 'numéro de téléphone'
                }`}
                content="En cas d'autres modifications apportées à votre compte, elles ne seront pas sauvegardées : assurez-vous de les enregistrer avant de poursuivre."
                cancelProps={cancelButton}
                saveProps={redirectButton}
                icon={<InfoIcon />}
            />
        </>
    )
}

export default RequiredExpertForm
